import { render, staticRenderFns } from "./editannouncement.vue?vue&type=template&id=0a9eec44&scoped=true"
import script from "./editannouncement.vue?vue&type=script&lang=js"
export * from "./editannouncement.vue?vue&type=script&lang=js"
import style0 from "./editannouncement.vue?vue&type=style&index=0&id=0a9eec44&prod&scoped=true&lang=css"
import style1 from "./editannouncement.vue?vue&type=style&index=1&id=0a9eec44&prod&scoped=true&lang=css"
import style2 from "./editannouncement.vue?vue&type=style&index=2&id=0a9eec44&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a9eec44",
  null
  
)

export default component.exports